const BulbIcon = props => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 18 18"
    xmlns="http://www.w3.org/2000/svg"
    fill="#4079F5"
    {...props}
  >
    <path d="M6.75 15.75C6.75 16.125 7.05 16.5 7.5 16.5H10.5C10.95 16.5 11.25 16.125 11.25 15.75V15H6.75V15.75ZM9 1.5C6.075 1.5 3.75 3.825 3.75 6.75C3.75 8.55 4.65 10.125 6 11.025V12.75C6 13.125 6.3 13.5 6.75 13.5H11.25C11.7 13.5 12 13.125 12 12.75V11.025C13.35 10.05 14.25 8.475 14.25 6.75C14.25 3.825 11.925 1.5 9 1.5Z" />
  </svg>
)

export default BulbIcon
